<!-- @format -->
<message-modal>
  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <h3 class="modal_heading margin-spacing-3_bottom">
        申し送り事項
      </h3>

      <div class="modal__content_inner">

        <p class="text">{props.message}</p>


      </div>
      <!--/.modal__content_inner-->
      <div class="wrap_button margin-spacing-2_top">
        <div
          class="button button-secondary-large button-border margin-spacing-1_right"
          type="button"
          value="閉じる"
          onclick="{ props.onClose }"
        >
          閉じる
        </div>

      </div>

      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>

  <script>
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      }
    };
  </script>
</message-modal>
